import type { GetExternalConfig } from '@bb/domain/dist/types/dto/AppointmentController/getExternalConfig';
import Axios from 'axios';

const getExternalAppointmentConfig = async (listingId: string) => {
  const { data } = await Axios.get<GetExternalConfig>(
    `listing/${listingId}/appointments/external_config`,
  );
  return data;
};

export default getExternalAppointmentConfig;
